export const generateIndependentTicketform = (data, existing, addNew) => {
    try {
        let ticket = { ...data }
        ticket.location_data.forEach(location => {
            if (ticket.fk_customer_id) {
                location.fk_customer_id = ticket.fk_customer_id
            }
            if (ticket.end_user_id) {
                location.end_user_id = ticket.end_user_id
            }
            
            location.hard_copy_required = location.hard_copy_required ? parseInt(location.hard_copy_required) : 0
            location.self_pickup_required = location.self_pickup_required ? parseInt(location.self_pickup_required) : 0
            location.is_boq_required = location.is_boq_required ? parseInt(location.is_boq_required) : 0
            location.is_noc_required = 1
            location.fk_noc_template_id = location.fk_noc_template_id || 0
            delete location.trackingDetails
            delete location.customer
            delete location.sow
            delete location.sign_off_report
            if (!addNew) {
                if (existing) {
                    location.use_existing = 1;
                } else {
                    location.create_new = 1;
                }
            }
            if (location.boq_data && Array.isArray(location.boq_data) &&
                location.boq_data.length > 0) {
                location.boq_data.forEach((boq, boqIndex) => {
                    if (!boq.asset_type_id || boq.asset_type_id === "") {
                        location.boq_data.splice(boqIndex, 1)
                    }
                })
            }
        })
        if (ticket.fk_customer_id) {
            delete ticket.fk_customer_id
        }
        if (ticket.end_user_id) {
            delete ticket.end_user_id
        }
        return ticket
    } catch (error) {
        console.error('form', error)
    }
}

export const generateCreateProjectform = project => {
    const isTruthyValue = item => {
      return ![ undefined, null].includes(item);
    };
    try {
        let form = new FormData();
        Object.entries(project).forEach(([key, value]) => {
            if(key === 'sow' && isTruthyValue(value)){
                form.set('sow', value[0]);
            }else if(key === 'sign_off_report' && isTruthyValue(value)){
                form.set('sign_off_report', value[0]);  
            }else if(key === 'teams'){
              value.map((teamId, reqindex) => {
                return form.append(`teams[${reqindex}]`, teamId)
              });
            }
            else{
              if(isTruthyValue(value)) form.set(key, value);
            }
        });
        return form
    } catch (error) {
        console.error(error)
    }
}

export const adminInviteUserForm = (data) => {
	let form = new FormData();
	 Object.keys(data).forEach(key => {
		if (key === 'sp_city_ids') {
		  if (Array.isArray(data.sp_city_ids)) {
			data.sp_city_ids.map(item => {
			  return form.append(`user[0][sp_city_ids][]`, parseInt(item));
			});
		  } else {
			form.append(`user[0][sp_city_ids][]`, parseInt(data.sp_city_ids));
		  }
		} else if (key === 'sp_use_cases') {
		  data.sp_use_cases.map(item => {
			return form.append(`user[0][sp_use_cases][]`, parseInt(item));
		  });
		} else if (key === 'sp_have_gst') {
		  if (data.hasOwnProperty('sp_have_gst') && data.sp_have_gst) {
			form.set(`user[0][sp_have_gst]`, 1);
		  } else {
			form.set(`user[0][sp_have_gst]`, 0);
		  }
		} else if (key === 'sp_pan_card_image') {
		  form.set(
			`user[0][sp_pan_card_image]`,
			data.sp_pan_card_image ? data.sp_pan_card_image[0] : ''
		  );
		} else if (key === 'fe_adhar_card_image') {
		  form.set(
			`user[0][fe_adhar_card_image]`,
			data.fe_adhar_card_image ? data.fe_adhar_card_image[0] : ''
		  );
		} else {
		  form.set(`user[0][${key}]`, data[key]);
		}
	  });
	  return form;
}
